<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div
    :class="[
      'flex bg-primary-white rounded-2xl items-start',
      { 'pointer-events-none ': props.disabled }
    ]"
    @click="() => emit('change', props.value)"
  >
    <div class="relative flex items-center">
      <input
        :id="name + props.value"
        :disabled="props.disabled"
        type="radio"
        :class="[
          'peer relative appearance-none shrink-0 w-5 h-5 border-[2px] rounded-full mt-0.5',
          'checked:border-0',
          'disabled:border-steel-400 disabled:bg-steel-400'
        ]"
        :name="name"
        :value="props.value"
        :checked="selected"
      />
      <div
        class="absolute hidden peer-checked:block w-5 h-5 rounded-full bg-transperent border-[6px] border-black"
      />
    </div>

    <label class="ml-4 mb-0 font-bold select-none" :for="name + props.value">
      <slot
    /></label>
  </div>
</template>

<script setup lang="ts">
interface InputProps {
  value: string
  name: string
  disabled?: boolean
  selected?: boolean
  manual?: boolean
}
const emit = defineEmits<{
  (e: 'change', value: string): void
}>()

const props = defineProps<InputProps>()

const name = toRef(props, 'name')
</script>
